
import Support24 from "../../../assets/filled/Support24.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Support24Icon({ className, dataTestid = "Support24Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Support24 data-testid={dataTestid} className={classes} {...rest} />
  );
}
